import { Axios } from '@src/context/Api/includes/Axios/Axios';
import { logger } from '@src/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * GetWorkableItem
 *
 * Retrieves a workable item from the remote API via an authenticated request.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const GetWorkableItem = async (payload = {}) => {
  try {
    const theQueryKey = payload?.[0];
    const thePayload = payload?.[1];

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/workitem/${thePayload?.workableItemId}`,
      },
      method: 'GET',
      params: { queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);
    return remoteResponse?.data;
  } catch (error) {
    logger.error('src/requests/queries/GetWorkableItem.js -> GetWorkableItem()', false, error);

    throw error;
  }
};
